export default class AgendamentoEnvioMensagemStatusEnum {
    static Rascunho = 1
    static Agendado = 2
    static Cancelar = 3
    static EmProcessamento = 4
    static Processado = 5
}
